export function target() {
  return (
    ['BannerWithMenu', 'PromoHeader'].includes(this.module) &&
    !this.data.buttons
  );
}

export function migrate() {
  const { buttonText, buttonUrl, buttonFeatured } = this.data;
  delete this.buttonText;
  delete this.buttonUrl;
  delete this.buttonFeatured;

  if (buttonText && buttonUrl?.value) {
    this.data.buttons = [
      {
        buttonText,
        buttonUrl,
        buttonFeatured,
      },
    ];
  }
}
